import script from "./TransferSendPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferSendPage.vue?vue&type=script&setup=true&lang=js"

import "./TransferSendPage.vue?vue&type=style&index=0&id=57938d8f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57938d8f"]])

export default __exports__